import React from "react";

const SvgR = props => (
  <svg
    style={{
      isolation: "isolate"
    }}
    viewBox="0 0 205 200"
    {...props}
  >
    <defs>
      <clipPath id="R_svg__a">
        <path d="M0 0h205v200H0z" />
      </clipPath>
    </defs>
    <g clipPath="url(#R_svg__a)">
      <path
        d="M99.76 161.6a11.631 11.631 0 0 1 7.16 20.81 11.818 11.818 0 0 1-4.6 2.21l8.15 9.59h-3.55l-7.86-9.3h-2.42v9.3h-2.63v-30h-3.94l1.58-2.64 8.11.03zm-3.12 20.67h3.12a8.48 8.48 0 0 0 6.52-2.68 9.001 9.001 0 0 0 2.49-6.33 8.741 8.741 0 0 0-1.29-4.75 8.847 8.847 0 0 0-3.36-3.16 9.12 9.12 0 0 0-4.36-1.1h-3.12v18.02z"
        fill="#1D1D1B"
      />
    </g>
  </svg>
);

export default SvgR;